import { render } from "./klbdan.vue?vue&type=template&id=78d32fd2&scoped=true"
import script from "./klbdan.vue?vue&type=script&lang=js"
export * from "./klbdan.vue?vue&type=script&lang=js"

import "./klbdan.vue?vue&type=style&index=0&id=78d32fd2&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d32fd2"]])

export default __exports__